import { type PropsWithChildren } from 'react';
import Animated, { Easing, FadeIn } from 'react-native-reanimated';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return <Animated.View entering={CONTAINER_ENTERING}>{children}</Animated.View>;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTAINER_ENTERING = FadeIn.duration(theme.transitions.base).easing(Easing.out(Easing.cubic));
